module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/down_arrow-fa78c8827a6059ee6e56ad92abbcfdf5.svg&quot;;"